<template>
  <AppTableControl
    @export-excel-clicked="downloadReport(1)"
    @export-pdf-clicked="downloadReport(2)"
    @query-debounced="searchByName"
    @search-clicked="beginSearch"
  >
    <template #filters>
      <div class="d-flex">
        <b-form-group label="Date">
          <DatePicker v-model="date" />
        </b-form-group>

        <b-form-group class="ml-4" label="Status">
          <b-form-select v-model="status" :options="statusOptions">
          </b-form-select>
        </b-form-group>
      </div>
    </template>
  </AppTableControl>
</template>

<script>
import dayjs from "dayjs";
import "vue2-datepicker/index.css";
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
import DatePicker from "vue2-datepicker";

export default {
  name: "TeacherDailyAttendanceTableControl",
  components: { AppTableControl, DatePicker },
  data() {
    return {
      date: dayjs().toDate(),
      status: null,
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: 1, text: "Working" },
        { value: 2, text: "Absent" },
        { value: 3, text: "Leave" },
        { value: 4, text: "Away" },
        { value: 5, text: "Holiday" },
        { value: 5, text: "Offday" },
      ],
    };
  },
  beforeDestroy() {
    console.log("Resetting name base (all) query filter");

    this.$store.dispatch("changeTeacherDailyAttendanceNameFilter", {
      name: null,
    });

    this.$store.dispatch("changeTeacherDailyAttendanceDateFilter", {
      date: dayjs().format(),
    });
  },
  methods: {
    /**
     * Download excel
     *
     * @param type
     */
    async downloadReport(type) {
      try {
        this.$bvToast.toast("Downloading Report . . .", {
          variant: "primary",
        });

        const response = await this.$store.dispatch(
          "downloadTeacherDailyAttendanceReport",
          {
            type: type,
          }
        );

        console.log(response);
        console.log("Successfully downloaded report of type : ", type);

        this.$bvToast.toast("Successfully downloaded report . . .", {
          variant: "primary",
        });
      } catch (e) {
        console.error(e);

        await this.$bvModal.msgBoxOk("Error", {
          okVariant: "danger",
        });
      }
    },

    /**
     * Search by name.
     *
     * @param nameQuery
     */
    searchByName(nameQuery) {
      console.log(nameQuery);

      this.$store.dispatch("changeTeacherDailyAttendanceNameFilter", {
        name: nameQuery,
      });

      this.$store.dispatch("fetchTeacherDailyAttendanceList");
    },

    /**
     * Search date
     */
    beginSearch() {
      console.log("Begin search", this.date);

      const newDate = dayjs(this.date);

      console.log("newDate", newDate);

      this.$store.dispatch("changeTeacherDailyAttendanceDateFilter", {
        date: newDate.format(),
      });

      this.$store.dispatch("changeTeacherDailyAttendanceStatusFilter", {
        status: this.status,
      });

      this.$store.dispatch("fetchTeacherDailyAttendanceList");
    },
  },
};
</script>

<style scoped></style>
